<div class="dialogContainer">
  <!--mat-dialog-content-->
  <div class="contentContainer">
    {{message}}
  </div>
  <!--mat-dialog-actions-->
  <div class="actionsContainer">
    <button class="btn-yes" mat-button (click)="onNoClick()">Ok</button>
    <!--[label]="Ok"-->
    <!--
  <button pButton pRipple type="button"
          class="p-button-success p-button-raised" (click)="onNoClick()">
    OK
  </button>
  -->
    <!--style="margin-left: 2px;" icon="fas fa-save"-->
    <!--
    <p-button styleClass="p-button-raised p-button-success" label="Ok" (onClick)="onNoClick()">
    </p-button>
    -->

  </div>
</div>
